'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { trackErrorCustom } from '@libs/analytics';
import { useMiniPdpDrawer } from './use-mini-pdp-drawer';
const SITE_SECTION = 'mini pdp';
const ERROR_MESSAGE = 'unexpected error';
export function useMiniPdpErrorAnalytics(hasUnexpectedError) {
  const $ = _c(5);
  const isOpen = useMiniPdpDrawer(_temp);
  const productId = useMiniPdpDrawer(_temp2);
  const lastTrackedKeyRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== hasUnexpectedError || $[1] !== isOpen || $[2] !== productId) {
    t0 = () => {
      if (!isOpen || !hasUnexpectedError) {
        lastTrackedKeyRef.current = null;
        return;
      }
      if (!productId || lastTrackedKeyRef.current === productId) {
        return;
      }
      lastTrackedKeyRef.current = productId;
      trackErrorCustom(SITE_SECTION, ERROR_MESSAGE);
    };
    t1 = [hasUnexpectedError, isOpen, productId];
    $[0] = hasUnexpectedError;
    $[1] = isOpen;
    $[2] = productId;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
}
function _temp2(state_0) {
  return state_0.productId;
}
function _temp(state) {
  return state.isOpen;
}